import { NavLink } from 'react-router-dom';
import './adminHeader.css';

const AdminHeader = () => {
    return (
        <div className='admin-header'>
            <nav>
                <NavLink to="/admin/dashboard" className={({ isActive }) => (isActive ? 'active' : '')}>
                    Dashboard
                </NavLink>
                <NavLink to="/admin/gradebook" className={({ isActive }) => (isActive ? 'active' : '')}>
                    Gradebook
                </NavLink>
                <NavLink to="/admin/analytics" className={({ isActive }) => (isActive ? 'active' : '')}>
                    Analytics
                </NavLink>
               
            </nav>
           
           
        </div>
    )
}


export default AdminHeader;